import { useState, useEffect } from 'react';

function Brush(props) {
    // Set up the initial rectangle position and size
    const [x, setX] = useState(null);
    const [y, setY] = useState(null);
    const [left, setLeft] = useState();
    const [top, setTop] = useState();
    const [isTouchDown, setIsTouchDown] = useState(false);

    useEffect(() => {
        const svg = document.getElementById('svgtest');
        const { left, top, width, height } = svg.getBoundingClientRect();
        setLeft(left);
        setTop(top);
        svg.addEventListener('touchstart', handleTouchStart);
        svg.addEventListener('touchmove', handleTouchMove);
        svg.addEventListener('touchend', handleTouchEnd);
        svg.addEventListener('mousedown', handleMouseDown);
        svg.addEventListener('mousemove', handleMouseMove);
        svg.addEventListener('mouseup', handleMouseUp);
        return () => {
            svg.removeEventListener('touchstart', handleTouchStart);
            svg.removeEventListener('touchmove', handleTouchMove);
            svg.removeEventListener('touchend', handleTouchEnd);
            svg.removeEventListener('mousedown', handleMouseDown);
            svg.removeEventListener('mousemove', handleMouseMove);
            svg.removeEventListener('mouseup', handleMouseUp);
        };
    });

    function handleTouchStart(e) {
        if (top && left) {
            setX(e.touches[0].clientX - left);
            setY(e.touches[0].clientY - top);
            setIsTouchDown(true);
        }
    }

    function handleTouchMove(e) {
        if (isTouchDown === false) {
            setIsTouchDown(true);
        }
        if (isTouchDown) {
            setX(e.touches[0].clientX - left);
            setY(e.touches[0].clientY - top);
        }
    }

    function handleTouchEnd(e) {
        setIsTouchDown(false);
    }

    function handleMouseDown(e) {
        if (top && left) {
            setX(e.clientX - left);
            setY(e.clientY - top);
            setIsTouchDown(true);
        }
    }

    function handleMouseMove(e) {
        if (isTouchDown === false) {
            setIsTouchDown(true);
        }
        if (isTouchDown) {
            setX(e.clientX - left);
            setY(e.clientY - top);
        }
    }

    function handleMouseUp(e) {
        setIsTouchDown(false);
    }

    return (
        <>
            {x && y &&
                <rect
                    x={x - props.radius / 2}
                    y={y - props.radius / 2}
                    width={props.radius}
                    height={props.radius}
                    fill="#FFFFFF"
                    stroke="#000000"
                    strokeWidth="1"
                    display={isTouchDown ? "inline" : "none"}
                />
            }
        </>
    );
}

export default Brush;
